import type { CanvasClass } from './creative-template.types';
import type { SceneGraph } from './creative-template-example.types';

export type ExtractionStatus = 'pending' | 'running' | 'succeeded' | 'failed';

export interface ExtractedStructureSummary {
  layout_archetype?: string | null;
  element_counts?: Record<string, number> | null;
  type_scale_ratios?: Record<string, number> | null;
  margin_fraction?: number | null;
}

export interface ExtractedStructure extends ExtractedStructureSummary {
  canvas_class?: CanvasClass;
  layers?: SceneGraph['layers'];
  margin_fraction_of_short_edge?: number | null;
  text_element_count?: number | null;
  shape_layer_count?: number | null;
  color_role_count?: number | null;
  hero_treatment?: string | null;
  text_over_image?: boolean | null;
  dominant_alignment?: string | null;
  palette_hexes?: string[] | null;
}

export interface DesignerExemplar {
  id: string;
  name: string;
  canvas_class: CanvasClass;
  vertical: string;
  notes: string;
  active: boolean;
  extraction_status: ExtractionStatus;
  extracted_structure: ExtractedStructure | null;
  ratio_mismatch: boolean;
  image_url: string | null;
  image_width: number | null;
  image_height: number | null;
  created_at: string;
  updated_at: string;
}

export interface DesignerExemplarWritePayload {
  name?: string;
  canvas_class?: CanvasClass;
  vertical?: string;
  notes?: string;
  active?: boolean;
}

export interface DesignerExemplarCoverageClass {
  canvas_class: CanvasClass;
  display_name?: string;
  count: number;
  active_count: number;
  is_thin: boolean;
}

export interface DesignerExemplarCoverage {
  target_per_class: number;
  classes: DesignerExemplarCoverageClass[];
}

export interface DesignerAgentConfig {
  designer_agent_enabled: boolean;
}

export interface DesignerExemplarSignedUrlRequest {
  content_type: string;
  extension: string;
}

export interface DesignerExemplarSignedUrlResponse {
  signed_url: string;
  object_name: string;
  gcs_uri?: string;
}

export interface DesignerExemplarImageCommittedRequest {
  object_path?: string;
  gcs_uri?: string;
}

export interface DesignerCanvasClass {
  slug: CanvasClass;
  display_name: string;
  reference_width: number;
  reference_height: number;
  tolerance: number;
  active: boolean;
}

export interface DesignerCanvasClassWritePayload {
  slug?: CanvasClass;
  display_name?: string;
  reference_width?: number;
  reference_height?: number;
  tolerance?: number;
  active?: boolean;
}

export const EXTRACTION_STATUS_OPTIONS: ExtractionStatus[] = [
  'pending',
  'running',
  'succeeded',
  'failed',
];

export const COMMON_VERTICAL_OPTIONS = [
  'qsr',
  'retail',
  'healthcare',
  'finance',
  'automotive',
  'travel',
  'entertainment',
  'technology',
];
